import type { FilterGroup } from '@bambi/api-client/schemas';
import { createColumnHelper } from '@tanstack/react-table';

import { ManageFilterGroupCell } from './ManageFilterGroupCell';
import { filterGroupFilters } from 'src/common/FilterGroup/FilterGroupFilters';

const helper = createColumnHelper<FilterGroup>();
export const columns = [
  helper.accessor('group_name', {
    header: 'Name',
  }),
  helper.accessor('description', {
    header: 'Description',
  }),
  helper.accessor('slug', {
    header: 'URL Slug',
  }),
  helper.accessor('filterset', {
    header: 'Set',
  }),
  helper.accessor('filters', {
    header: 'Filters',
    cell({ getValue }) {
      return Object.keys(filterGroupFilters(getValue())).length;
    },
  }),
  helper.display({
    header: 'Manage',
    enableHiding: false,
    cell({ row }) {
      return <ManageFilterGroupCell id={row.original.id} />;
    },
  }),
];
